export default function Space(props) {
  const { flex, width, height, style, ...rest } = props

  const spaceStyles = {
    ...styles.default,
    flex: flex === true ? 1 : flex,
    width,
    height,
    ...style,
}

  return (
    <div
      style={spaceStyles}
      {...rest}
    />
  )
}

Space.ColumnBreak = props => <Space height={24} {...props} />
Space.ColumnSemiBreak = props => <Space height={12} {...props} />
Space.ColumnGap = props => <Space height={8} {...props} />

Space.RowBreak = props => <Space width={24} {...props} />
Space.RowSemiBreak = props => <Space width={12} {...props} />
Space.RowGap = props => <Space width={8} {...props} />


const styles = {
  default: {
    flex: 0,
  }
}
